import { render, staticRenderFns } from "./ImpactLeftSidebar.vue?vue&type=template&id=fd475f0e&scoped=true&"
import script from "./ImpactLeftSidebar.vue?vue&type=script&lang=ts&"
export * from "./ImpactLeftSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd475f0e",
  null
  
)

export default component.exports